import {roadmapDataPercentage} from "../js/roadmapDataPercentage.js";
import {roadmapDataTime} from "../js/roadmapDataTime.js";
import unicornEasterRoadmap from "../images/6.png";

function spanClicked() {
    try {
        document.getElementById('unicorn-roadmap').classList.add('show');
    }
    catch(err){

    }
}

const Roadmap = () => {
    return (
    <section id="roadmapContainer">
        <a href="#roadmap" className="anchor-target" name="roadmap">roadmap</a>
        <h2> Roadmap</h2>
        <p> Creating a realistic roadmap was our priority.</p>
        <p> That's why we have two separate roadmaps, time-based and mint-based, which will progress in parallel.</p>
        <p> This way, development based-items (enhanced token pages, token gallery and marketplace development) will be separated from funding-based items (donations, 3D printing). And the community can benefit more, and be less dependent on minted tokens.</p>
        {/* <p> This is the fourth paragraph and if you're reading this, you're winning. With a single <span className="clickable-span-hidden"  onClick={() => spanClicked()}> click. </span></p> 
        <img id="unicorn-roadmap" className="unicornRoadmap" src={unicornEasterRoadmap} alt="Suddenly Unicorns 7" /> */}
        
        <div className="roadmap-title-container">
            <h3> Roadmap (Time-Based)</h3>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="48px" height="48px" x="0px" y="0px" viewBox="0 0 120 120">
                <g>
                    <path  fill="#00D566" d="M99.5,52.8l-1.9,4.7c-0.6,1.6-0.6,3.3,0,4.9l1.9,4.7c1.1,2.8,0.2,6-2.3,7.8L93,77.8c-1.4,1-2.3,2.5-2.7,4.1
                        l-0.9,5c-0.6,3-3.1,5.2-6.1,5.3l-5.1,0.2c-1.7,0.1-3.3,0.8-4.5,2l-3.5,3.7c-2.1,2.2-5.4,2.7-8,1.2l-4.4-2.6
                        c-1.5-0.9-3.2-1.1-4.9-0.7l-5,1.2c-2.9,0.7-6-0.7-7.4-3.4l-2.3-4.6c-0.8-1.5-2.1-2.7-3.7-3.2l-4.8-1.6c-2.9-1-4.7-3.8-4.4-6.8
                        l0.5-5.1c0.2-1.7-0.3-3.4-1.4-4.7l-3.2-4c-1.9-2.4-1.9-5.7,0-8.1l3.2-4c1.1-1.3,1.6-3,1.4-4.7l-0.5-5.1c-0.3-3,1.5-5.8,4.4-6.8
                        l4.8-1.6c1.6-0.5,2.9-1.7,3.7-3.2l2.3-4.6c1.4-2.7,4.4-4.1,7.4-3.4l5,1.2c1.6,0.4,3.4,0.2,4.9-0.7l4.4-2.6c2.6-1.5,5.9-1.1,8,1.2
                        l3.5,3.7c1.2,1.2,2.8,2,4.5,2l5.1,0.2c3,0.1,5.6,2.3,6.1,5.3l0.9,5c0.3,1.7,1.3,3.2,2.7,4.1l4.2,2.9C99.7,46.8,100.7,50,99.5,52.8z
                        "/>
                    <g opacity="0.15">
                        <path d="M43.4,93.5l-2.3-4.6c-0.8-1.5-2.1-2.7-3.7-3.2l-4.8-1.6c-2.9-1-4.7-3.8-4.4-6.8l0.5-5.1c0.2-1.7-0.3-3.4-1.4-4.7l-3.2-4
                            c-1.9-2.4-1.9-5.7,0-8.1l3.2-4c1.1-1.3,1.6-3,1.4-4.7l-0.5-5.1c-0.3-3,1.5-5.8,4.4-6.8l4.8-1.6c1.6-0.5,2.9-1.7,3.7-3.2l2.3-4.6
                            c0.8-1.6,2.2-2.7,3.7-3.2c-2.7-0.4-5.4,1-6.6,3.5l-2.3,4.6c-0.8,1.5-2.1,2.7-3.7,3.2l-4.8,1.6c-2.9,1-4.7,3.8-4.4,6.8l0.5,5.1
                            c0.2,1.7-0.3,3.4-1.4,4.7l-3.2,4c-1.9,2.4-1.9,5.7,0,8.1l3.2,4c1.1,1.3,1.6,3,1.4,4.7l-0.5,5.1c-0.3,3,1.5,5.8,4.4,6.8l4.8,1.6
                            c1.6,0.5,2.9,1.7,3.7,3.2l2.3,4.6c1.4,2.7,4.4,4.1,7.4,3.4l0.6-0.1C46.3,96.7,44.4,95.5,43.4,93.5z"/>
                        <path d="M60.6,22.5l4.4-2.6c0.4-0.2,0.8-0.4,1.2-0.5c-1.4-0.2-2.9,0.1-4.1,0.8l-4.4,2.6c-0.4,0.2-0.8,0.4-1.2,0.5
                            C57.9,23.5,59.3,23.3,60.6,22.5z"/>
                        <path d="M81,92c-0.5,0-1,0.1-1.4,0.2l3.6-0.2c0.5,0,0.9-0.1,1.4-0.2L81,92z"/>
                        <path d="M65,98.9l-4.4-2.6c-1.5-0.9-3.2-1.1-4.9-0.7l-0.6,0.1c0.9,0.1,1.7,0.4,2.5,0.8l4.4,2.6c1.7,1,3.6,1.1,5.4,0.5
                            C66.6,99.6,65.8,99.4,65,98.9z"/>
                    </g>
                    <polyline  fill="#00D566" points="44,53.6 56.5,67.9 82.1,47.3 	"/>
                    <path  fill="#FFFFFF" d="M53.5,75.3c-1.4,0-2.8-0.6-3.8-1.7L37.2,59.3c-1.8-2.1-1.6-5.2,0.4-7.1c2.1-1.8,5.2-1.6,7.1,0.4l9.4,10.7
                        l21.9-17.6c2.1-1.7,5.3-1.4,7,0.8c1.7,2.2,1.4,5.3-0.8,7L56.6,74.2C55.7,74.9,54.6,75.3,53.5,75.3z"/>
                </g>
            </svg>
        </div>
        
        <div className="roadmap">
            {roadmapDataTime.map(({ percentageTitle, percentageSub, detailTitle, detailSub, itemComplete, comments}) => (
                <div key={(percentageTitle + detailTitle).replaceAll(' ', '-')} className="roadmap-item">
                    <div className="roadmap-item-percentage">
                        <p className="roadmap-item-percentage-title"> {percentageTitle} </p>
                        <p className="roadmap-item-percentage-sub"> {percentageSub} </p>
                    </div>
                    <div className="roadmap-item-detail">
                        <div>
                            <p className="roadmap-item-detail-title"> {detailTitle} </p>
                            { itemComplete && 
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" x="0px" y="0px" viewBox="0 0 120 120">
                                    <g>
                                        <path  fill="#00D566" d="M99.5,52.8l-1.9,4.7c-0.6,1.6-0.6,3.3,0,4.9l1.9,4.7c1.1,2.8,0.2,6-2.3,7.8L93,77.8c-1.4,1-2.3,2.5-2.7,4.1
                                            l-0.9,5c-0.6,3-3.1,5.2-6.1,5.3l-5.1,0.2c-1.7,0.1-3.3,0.8-4.5,2l-3.5,3.7c-2.1,2.2-5.4,2.7-8,1.2l-4.4-2.6
                                            c-1.5-0.9-3.2-1.1-4.9-0.7l-5,1.2c-2.9,0.7-6-0.7-7.4-3.4l-2.3-4.6c-0.8-1.5-2.1-2.7-3.7-3.2l-4.8-1.6c-2.9-1-4.7-3.8-4.4-6.8
                                            l0.5-5.1c0.2-1.7-0.3-3.4-1.4-4.7l-3.2-4c-1.9-2.4-1.9-5.7,0-8.1l3.2-4c1.1-1.3,1.6-3,1.4-4.7l-0.5-5.1c-0.3-3,1.5-5.8,4.4-6.8
                                            l4.8-1.6c1.6-0.5,2.9-1.7,3.7-3.2l2.3-4.6c1.4-2.7,4.4-4.1,7.4-3.4l5,1.2c1.6,0.4,3.4,0.2,4.9-0.7l4.4-2.6c2.6-1.5,5.9-1.1,8,1.2
                                            l3.5,3.7c1.2,1.2,2.8,2,4.5,2l5.1,0.2c3,0.1,5.6,2.3,6.1,5.3l0.9,5c0.3,1.7,1.3,3.2,2.7,4.1l4.2,2.9C99.7,46.8,100.7,50,99.5,52.8z
                                            "/>
                                        <g opacity="0.15">
                                            <path d="M43.4,93.5l-2.3-4.6c-0.8-1.5-2.1-2.7-3.7-3.2l-4.8-1.6c-2.9-1-4.7-3.8-4.4-6.8l0.5-5.1c0.2-1.7-0.3-3.4-1.4-4.7l-3.2-4
                                                c-1.9-2.4-1.9-5.7,0-8.1l3.2-4c1.1-1.3,1.6-3,1.4-4.7l-0.5-5.1c-0.3-3,1.5-5.8,4.4-6.8l4.8-1.6c1.6-0.5,2.9-1.7,3.7-3.2l2.3-4.6
                                                c0.8-1.6,2.2-2.7,3.7-3.2c-2.7-0.4-5.4,1-6.6,3.5l-2.3,4.6c-0.8,1.5-2.1,2.7-3.7,3.2l-4.8,1.6c-2.9,1-4.7,3.8-4.4,6.8l0.5,5.1
                                                c0.2,1.7-0.3,3.4-1.4,4.7l-3.2,4c-1.9,2.4-1.9,5.7,0,8.1l3.2,4c1.1,1.3,1.6,3,1.4,4.7l-0.5,5.1c-0.3,3,1.5,5.8,4.4,6.8l4.8,1.6
                                                c1.6,0.5,2.9,1.7,3.7,3.2l2.3,4.6c1.4,2.7,4.4,4.1,7.4,3.4l0.6-0.1C46.3,96.7,44.4,95.5,43.4,93.5z"/>
                                            <path d="M60.6,22.5l4.4-2.6c0.4-0.2,0.8-0.4,1.2-0.5c-1.4-0.2-2.9,0.1-4.1,0.8l-4.4,2.6c-0.4,0.2-0.8,0.4-1.2,0.5
                                                C57.9,23.5,59.3,23.3,60.6,22.5z"/>
                                            <path d="M81,92c-0.5,0-1,0.1-1.4,0.2l3.6-0.2c0.5,0,0.9-0.1,1.4-0.2L81,92z"/>
                                            <path d="M65,98.9l-4.4-2.6c-1.5-0.9-3.2-1.1-4.9-0.7l-0.6,0.1c0.9,0.1,1.7,0.4,2.5,0.8l4.4,2.6c1.7,1,3.6,1.1,5.4,0.5
                                                C66.6,99.6,65.8,99.4,65,98.9z"/>
                                        </g>
                                        <polyline  fill="#00D566" points="44,53.6 56.5,67.9 82.1,47.3 	"/>
                                        <path  fill="#FFFFFF" d="M53.5,75.3c-1.4,0-2.8-0.6-3.8-1.7L37.2,59.3c-1.8-2.1-1.6-5.2,0.4-7.1c2.1-1.8,5.2-1.6,7.1,0.4l9.4,10.7
                                            l21.9-17.6c2.1-1.7,5.3-1.4,7,0.8c1.7,2.2,1.4,5.3-0.8,7L56.6,74.2C55.7,74.9,54.6,75.3,53.5,75.3z"/>
                                    </g>
                                </svg>
                            }
                        </div>
                        <p className="roadmap-item-detail-sub" dangerouslySetInnerHTML={{ __html: detailSub}}></p>
                        { comments &&
                            <p className="roadmap-item-detail-comments" dangerouslySetInnerHTML={{ __html: comments}}></p>
                        }
                    </div>
                </div>
            ))}
        </div>

        <h3> Roadmap (Mint Based)</h3>
        <div className="roadmap">
            {roadmapDataPercentage.map(({ percentageTitle, percentageSub, detailTitle, detailSub }) => (
                <div key={(percentageTitle + detailTitle).replaceAll(' ', '-')} className="roadmap-item">
                    <div className="roadmap-item-percentage">
                        <p className="roadmap-item-percentage-title"> {percentageTitle} </p>
                        <p className="roadmap-item-percentage-sub"> {percentageSub} </p>
                    </div>
                    <div className="roadmap-item-detail">
                        <p className="roadmap-item-detail-title"> {detailTitle} </p>
                        <p className="roadmap-item-detail-sub" dangerouslySetInnerHTML={{ __html: detailSub}}></p>
                    </div>
                </div>
            ))}
        </div>
    </section>
    );
};

export default Roadmap;